import {
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { MdAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import useDataFetching from "hooks/useDataFetching";
import { config } from "variables/config";
import AddUser from "./AddUser";
import UpdateUserInformations from "./UpdateUserInformations";
import PreloaderSpinner from "components/PreloaderSpinner";
import { ROLES } from "Constaints";
import { useAuthUser } from "react-auth-kit";
import { CHECK_PERMISSIONS } from "Constaints";
import { Box, capitalize, Chip, TextField, Typography } from "@mui/material";
import MButton from "components/Mbutton";
import MuiTable from "components/MuiTable";
import { ACCOUNT_HEADER } from "Constaints";
import usePostAxiosData from "hooks/usePostAxiosData";
import EnterpriseAccountDetails from "./EnterpriseAccountDetails";
import PaginateBox from "components/PaginateBox";
import MuiSelect from "components/MuiSelect";
import { castToRequestParams } from "utils";
import { Title } from "components/Title";
import { useTranslation } from 'react-i18next';


const EnterpriseAcccount = () => {
  const navigation = useNavigate();
  const { t } = useTranslation("admin_comptes"); 

  const [isOpenUM, setIsOpenUM] = useState(false);
  const [closeUM, setCloseUM] = useState(false);

  const auth = useAuthUser();
  const [params, setParams] = useState({ limit: 50, page: 0 });

  const [loadingU, errorU, users, fetchDataU] = useDataFetching(
    `${config.app.api_url}/roles/enterprises?${castToRequestParams(params)}`
  );

  const [filteredUsers, setFilteredUsers] = useState([]);
  console.log("🚀 ~ EnterpriseAcccount ~ filteredUsers:", filteredUsers);

  const [selectedUser, setselectedUser] = useState(null);
  const [searchterm, setSearchterm] = useState('');

  useEffect(() => {
    if (!users) return;
    if (searchterm) {
      setFilteredUsers({ ...filteredUsers, data: users?.data?.filter((u) => JSON.stringify(u)?.toLocaleLowerCase()?.includes(searchterm.toLocaleLowerCase())) });
    } else {
      setFilteredUsers(users);
    }
  }, [searchterm, users]);

  function createData(N, FirstName, LastName, Email, Phone, Enable, Options) {
    return {
      N, FirstName, LastName, Email, Phone, Enable, Options
    };
  }

  const [openDetail, setOpenDetail] = useState(false);
  const handleClick = (user) => {
    setselectedUser(user);
    setOpenDetail(true);
  };

  const handleCloseModal = () => {
    setselectedUser(null);
    setOpenDetail(false);
  };

  useEffect(() => {
    fetchDataU();
  }, [params, fetchDataU]); // Ajout de fetchDataU aux dépendances

  const rows = filteredUsers?.data?.sort((a, b) => a.id < b.id)?.map((item, index) => {
    return {
      handleClick: (e) => handleClick(item),
      datas: createData(
        (index + 1),
        item.firstName,
        item?.lastName,
        item?.mail,
        item?.phone,
        item?.enable ?
          <span className="bg-green-50 text-green-500 rounded-[60px] p-2 flex gap-2 content-center items-center"> {t("account_active_status")}</span> // Traduit
          :
          <span className="bg-red-100 text-red-500 rounded-[60px] p-2">{t("account_inactive_status")}</span>, // Traduit
        <div
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
          className="flex item-center justify-center gap-2">
          <MButton
            variant={"white"}
            style={{ borderRadius: 20 }}
            onClick={() => handleClick(item)}>
            {t("consult_button")} {/* Traduit */}
          </MButton>
        </div>,
      ),
    };
  });

  return (
    <div>
      {selectedUser && <EnterpriseAccountDetails
        fetchData={fetchDataU}
        openM={openDetail}
        onCloseM={handleCloseModal}
        get={fetchDataU}
        selectedUser={selectedUser}
      />}

      <div className="flex flex-col bg-white">
        <Box
          bg={"rgba(255, 255, 255, 1)"}
          boxShadow="lg"
          p={2}
          rounded={"md"}
          border="1px"
          borderColor="gray.200"
          className=" flex flex-wrap gap-1  items-center justify-between"
        >
          <Title title={t("list_enterprise_accounts_title")} />
          <div className="flex justify-end gap-2 pe-5">
            <TextField
              value={searchterm}
              onChange={(e) => setSearchterm(e.target.value)}
              id="outlined-search"
              label={t("search_placeholder")}
              type="search"
            />
            <MuiSelect
              wrapperClasses={"bg-white"}
              label={t("choose_status_label")}
              sort={false}
              value={params.status || ""}
              emptyLabel={t("status_all")}
              options={[
                { label: t("status_pending"), value: 'PENDING' },
                { label: t("status_completed"), value: 'COMPLETED' },
                { label: t("status_rejected"), value: 'REJECTED' },  
              ]}
              onChange={(event) => setParams({ ...params, status: event.target.value })}
            />
          </div>
        </Box>

        <MuiTable
          hidePagiation={false}
          loading={loadingU}
          limit={params?.limit}
          columns={ACCOUNT_HEADER(t)}
          rows={rows}
          textEmpty={t("no_work_permit")}
        />
      </div>
    </div>
  );
};

export default EnterpriseAcccount;